import { useState } from 'react';
import { patch } from '../lib/api';
import { useAuth } from '../lib/auth';
import { lang, setLang, t } from '../lib/i18n';

/**
 * Botón para cambiar entre español e inglés (recarga la página en el otro idioma).
 * Con sesión iniciada también guarda el idioma en la cuenta, para que los correos y
 * avisos lleguen en ese idioma. En el kiosko (persist=false) solo cambia la pantalla.
 */
export function LanguageSwitch({ light = false, persist = true }: { light?: boolean; persist?: boolean }) {
  const { me } = useAuth();
  const [busy, setBusy] = useState(false);
  const other = lang() === 'es' ? 'en' : 'es';
  const change = async () => {
    setBusy(true);
    if (persist && me) await patch('/api/me/profile', { language: other }).catch(() => undefined);
    setLang(other, { sessionOnly: !persist });
  };
  return (
    <button
      type="button"
      className="btn btn-ghost btn-sm"
      style={light ? { color: '#fff' } : undefined}
      onClick={change}
      disabled={busy}
      title={t('Cambiar idioma')}
      lang={other}
    >
      {other === 'en' ? 'English' : 'Español'}
    </button>
  );
}
